import { render, staticRenderFns } from "./RootQuietanziantiView.vue?vue&type=template&id=abd8a96c&"
import script from "./RootQuietanziantiView.vue?vue&type=script&lang=ts&"
export * from "./RootQuietanziantiView.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports